import styled from 'styled-components';
import DefaultUptimeTheme from 'utils/lumosTheme';
export const ContentLanguageSelectorWrapper = styled.div`
    ${({theme}: {theme: typeof DefaultUptimeTheme}) => `
    svg path {
        fill: black !important;
    }
    .MuiInputBase-root {
        width: 177px;
        height: 32px;
    }
    .Mui-focused .MuiOutlinedInput-notchedOutline {
        border-color: ${theme.uptimeColors.generalColors.button.outline.enabled} !important;
    }
    .MuiOutlinedInput-notchedOutline {
        border: 1px solid ${theme.uptimeColors.grayScales.darkerGray};
    }
    .MuiPaper-root {
        top: 305px !important;
        height: 200px !important;
    }
    `}
`;
